<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit">
    <v-card>
      <v-overlay :value="stripeLoading || setupIntentLoading" absolute :dark="false" color="white" opacity="0.90">
        <div class="text-center pa-5">
          <v-progress-circular indeterminate color="primary" class="mb-4"></v-progress-circular>
          <div>{{ $t('message.request_being_processed') }}</div>
        </div>
      </v-overlay>

      <v-card-title class="headline">{{ $t('message.add_card') }}</v-card-title>

      <v-card-text>
        <v-alert v-if="cardError" type="error">
          {{ cardError.message }}
        </v-alert>
        <v-text-field
          v-model="cardHolderName"
          :label="$t('message.card_holder_name')"
          required
          :rules="cardHolderNameRules"
        ></v-text-field>
        <CardElement
          ref="cardElement"
          class="mb-6"
          :data="stripeData"
          :show-postal-code="true"
          @change="cardComplete = $event.complete && cardHolderName"
          @success="cardCreateSuccess"
          @error="cardError = $event"
          @loading="stripeLoading = $event"
        />

        <v-alert type="info" text dense class="caption">
          {{ $t('message.postal_code_verification') }}
        </v-alert>

        <SaveCardTerms class="mt-6" @agree="saveCardAgree = $event" />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="$emit('close')">{{ $t('message.cancel') }}</v-btn>
        <v-btn text color="primary" type="submit" :disabled="!valid || !cardComplete || !saveCardAgree">{{
          $t('message.add_card')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import CardElement from '@/components/CardElement'
import fetch from '@/utils/fetch'
import SaveCardTerms from '@/components/SaveCardTerms'

export default {
  name: 'PaymentMethodCreate',
  components: {
    SaveCardTerms,
    CardElement
  },
  props: {
    legalEntity: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    valid: true,
    cardHolderName: null,
    cardComplete: false,
    stripeLoading: false,
    setupIntentLoading: false,
    cardError: null,
    saveCardAgree: false
  }),
  computed: {
    stripeData() {
      return {
        name: this.cardHolderName
      }
    },
    cardHolderNameRules() {
      return [
        v => {
          return (!!v && !!v.trim()) || this.$t('message.card_holder_name_is_required')
        }
      ]
    }
  },

  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.setupIntentLoading = true
        fetch(this.legalEntity['@id'] + '/setup_intent')
          .then(response => response.json())
          .then(data => {
            this.setupIntentLoading = false
            this.$refs.cardElement.confirmCardSetup(data.client_secret)
          })
          .catch(e => {
            this.setupIntentLoading = false
            this.cardError = e.message
          })
      }
    },

    cardCreateSuccess(response) {
      this.$emit('created', response)
    }
  }
}
</script>
